import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { CarrierStatsRow } from "components/CarrierStatsRow";
import { useAuthContext, useCarrierStats, useRoleContext } from "hooks";
import { useCompanyBranches } from "hooks/useCompanyBranches";

export function CompanyProfileBanner() {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { role, company, hasCompanyAdminRole } = useRoleContext();
  const { branches } = useCompanyBranches();

  const companyId = company?.company_type === "CARRIER" ? company.id : null;
  const { carrierMeta } = useCarrierStats({ companyId });

  const showCompanyRep = company?.company_type === "CARRIER";

  // Find the current user's branch name if they have a branch and are not an admin
  const getCurrentUserBranchName = (): string | null => {
    if (!role?.branch || hasCompanyAdminRole()) {
      return null;
    }

    const userBranch = branches.find(
      (branchMember) => branchMember.branch.id === role.branch,
    );
    return userBranch?.branch?.name ?? null;
  };

  const branchName = getCurrentUserBranchName();

  if (company == null || user == null || role == null) {
    return null;
  }

  const isCarrier = company.company_type === "CARRIER";
  const isShipperAdmin =
    company.company_type === "SHIPPER" && hasCompanyAdminRole();
  const isCompanyNameClickable = isCarrier || isShipperAdmin;

  const handleCompanyNameClick = () => {
    if (isCarrier) {
      navigate(`/companies/${company.id}/profile`);
    } else if (isShipperAdmin) {
      navigate(`/companies/${company.id}`);
    }
  };

  return (
    <Stack>
      <Box
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }}
        onClick={() => navigate("/account")}
      >
        <Typography variant="h6" color="white">
          {`${user?.first_name} ${user?.last_name}`}
        </Typography>
      </Box>
      <Box
        sx={
          isCompanyNameClickable
            ? {
                "&:hover": {
                  cursor: "pointer",
                },
              }
            : {}
        }
        onClick={isCompanyNameClickable ? handleCompanyNameClick : undefined}
      >
        <Typography noWrap variant="h6" color="white">
          {`${role?.company?.name ?? ""}${branchName ? ` - ${branchName}` : ""}`}
        </Typography>
      </Box>
      {showCompanyRep && carrierMeta && (
        <CarrierStatsRow
          carrierMeta={carrierMeta}
          withTrackingLinkSubmissionRate
        />
      )}
    </Stack>
  );
}
